module.exports = __webpack_public_path__ + "static/media/fonctionnalite.9b6efa1b.png";